export function newState(){
  return {
    active_entity: {
      type: '',
      id: -1
    },
  }
}

const localStorageData: any = localStorage.getItem('dataAccessStore')
const state = JSON.parse(localStorageData) || newState()

export default state
